module.exports = __webpack_public_path__ + "static/media/insta-icon.1f29385b.png";